import request from "../utils/request";

export function getNotifications(company, type) {
  let query = `?type=${type}`;
  if (company) {
    query += `&company=${company}`;
  }
  return request({
    url: `/notifications${query}`,
    method: "get",
  });
}

export function markAsRead(notification) {
  return request({
    url: `/notifications/${notification._id}`,
    method: "post",
    data: {
      read: true,
    },
  });
}
